import { FONT_SECONDARY } from "@/theme/typography"
import { Box, useTheme } from "@mui/material"
import { CarIconWrapperProps } from "./types"

const CarIconWrapper = ({ style, label, children }: CarIconWrapperProps) => {
  const theme = useTheme()
  return (
    <Box
      style={style}
      sx={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Box
        sx={{
          fontFamily: FONT_SECONDARY,
          fontSize: '0.625rem',
          paddingY: { xs: '2px', md: '5px' },
          paddingX: { xs: '2px', md: '7px' },
          textWrap: 'nowrap',
          position: 'absolute',
          top: '-30px',
          borderRadius: '3px',
          backgroundColor: theme.palette.common.white
        }}
      >
        {label}
      </Box>
      {children}
    </Box>
  )
}

export default CarIconWrapper